module.exports = __webpack_public_path__ + "static/essays-a7d59fed21c5faaf7bcc898812690d5b.jpg";